import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b603618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-guide-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-guide-status" }, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-guide-title" }, "Nurro, your guide", -1 /* HOISTED */))
const _hoisted_5 = {
  ref: "scrollEl",
  class: "nge-guide-scroll"
}
const _hoisted_6 = {
  key: 0,
  class: "nge-guide-empty"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "nge-guide-hi" }, "Hi! Ask me anything about proofreading, or tell me where you want to go.", -1 /* HOISTED */))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nge-guide-quest" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-guide-quest-label" }, "Learn more:", -1 /* HOISTED */))
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = {
  key: 0,
  class: "nge-guide-bubble nge-guide-bubble--user"
}
const _hoisted_13 = {
  key: 1,
  class: "nge-guide-botwrap"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "nge-guide-fb"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "nge-guide-correct"
}
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "nge-guide-correct-actions" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 2,
  class: "nge-guide-fb-thanks"
}
const _hoisted_24 = {
  key: 1,
  class: "nge-guide-msg nge-guide-msg--bot"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-guide-bubble nge-guide-bubble--bot nge-guide-typing" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createElementVNode("span")
], -1 /* HOISTED */))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "nge-guide-cmds"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-guide-cmds-hint" }, "Commands · Enter to run · Esc to ask instead", -1 /* HOISTED */))
const _hoisted_29 = ["onClick", "onMouseenter"]
const _hoisted_30 = { class: "nge-guide-cmd-icon" }
const _hoisted_31 = { class: "nge-guide-cmd-label" }
const _hoisted_32 = {
  key: 0,
  class: "nge-guide-cmd-key"
}
const _hoisted_33 = { class: "nge-guide-inputrow" }
const _hoisted_34 = ["placeholder"]
const _hoisted_35 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "nge-guide",
        style: _normalizeStyle($setup.dockStyle)
      }, [
        _createCommentVNode(" Resize handles (top edge, left edge, top-left corner) "),
        _createElementVNode("div", {
          class: "nge-guide-resize nge-guide-resize--corner",
          title: "Drag to resize",
          onMousedown: _cache[0] || (_cache[0] = $event => ($setup.startResize($event, 'corner')))
        }, null, 32 /* HYDRATE_EVENTS */),
        _createElementVNode("div", {
          class: "nge-guide-resize nge-guide-resize--top",
          onMousedown: _cache[1] || (_cache[1] = $event => ($setup.startResize($event, 'top')))
        }, null, 32 /* HYDRATE_EVENTS */),
        _createElementVNode("div", {
          class: "nge-guide-resize nge-guide-resize--left",
          onMousedown: _cache[2] || (_cache[2] = $event => ($setup.startResize($event, 'left')))
        }, null, 32 /* HYDRATE_EVENTS */),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: "nge-guide-avatar",
            style: _normalizeStyle({ backgroundImage: `url(${$setup.nurroAvatar})` })
          }, _hoisted_3, 4 /* STYLE */),
          _hoisted_4,
          _createElementVNode("button", {
            class: "nge-guide-close",
            title: "Close",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.emit('hide')))
          }, "✕")
        ]),
        _createElementVNode("div", _hoisted_5, [
          ($setup.messages.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SUGGESTIONS, (s) => {
                  return _createElementVNode("button", {
                    key: s,
                    class: "nge-guide-suggest",
                    onClick: $event => ($setup.send(s))
                  }, _toDisplayString(s), 9 /* TEXT, PROPS */, _hoisted_8)
                }), 64 /* STABLE_FRAGMENT */)),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.QUEST_LINKS, (res) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: res.id,
                      class: "nge-guide-quest-link",
                      href: res.url,
                      target: "_blank",
                      rel: "noopener",
                      title: res.description
                    }, _toDisplayString(res.icon) + " " + _toDisplayString(res.label), 9 /* TEXT, PROPS */, _hoisted_11))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (msg, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["nge-guide-msg", msg.role === 'user' ? 'nge-guide-msg--user' : 'nge-guide-msg--bot'])
            }, [
              (msg.role === 'user')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(msg.text), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", {
                      class: "nge-guide-bubble nge-guide-bubble--bot",
                      innerHTML: $setup.renderMarkdown(msg.text)
                    }, null, 8 /* PROPS */, _hoisted_14),
                    _createCommentVNode(" Feedback controls (only on real backend replies) "),
                    (msg.logId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (!msg.feedbackDone && !msg.correcting)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "nge-guide-fb-btn",
                                  title: "This was helpful",
                                  onClick: $event => ($setup.submitFeedback(msg, 'up'))
                                }, "👍", 8 /* PROPS */, _hoisted_16),
                                _createElementVNode("button", {
                                  class: "nge-guide-fb-btn",
                                  title: "This is wrong or unhelpful",
                                  onClick: $event => ($setup.startCorrection(msg))
                                }, "👎", 8 /* PROPS */, _hoisted_17)
                              ], 64 /* STABLE_FRAGMENT */))
                            : (msg.correcting)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": $event => ((msg.correctionText) = $event),
                                    class: "nge-guide-correct-input",
                                    rows: "2",
                                    placeholder: "What's the correct answer? (optional)"
                                  }, null, 8 /* PROPS */, _hoisted_19), [
                                    [_vModelText, msg.correctionText]
                                  ]),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("button", {
                                      class: "nge-guide-correct-send",
                                      onClick: $event => ($setup.submitFeedback(msg, 'down'))
                                    }, "Send correction", 8 /* PROPS */, _hoisted_21),
                                    _createElementVNode("button", {
                                      class: "nge-guide-correct-skip",
                                      onClick: $event => ($setup.submitFeedback(msg, 'down'))
                                    }, "Just mark wrong", 8 /* PROPS */, _hoisted_22)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(msg.feedback === 'up' ? 'Thanks! 🙌' : 'Thanks — logged. We\'ll use this to improve. ✓'), 1 /* TEXT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
            ], 2 /* CLASS */))
          }), 128 /* KEYED_FRAGMENT */)),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */),
        _createCommentVNode(" Instant command matches. Enter runs the highlighted one locally, with\n         no model round trip; Esc dismisses and lets you ask instead. "),
        ($setup.commandMatches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.commandMatches, (m, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: m.id,
                  class: _normalizeClass(["nge-guide-cmd", { 'nge-guide-cmd--sel': i === $setup.selectedCmd }]),
                  onClick: $event => ($setup.runCommand(m)),
                  onMouseenter: $event => ($setup.selectedCmd = i)
                }, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(m.icon), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(m.label), 1 /* TEXT */),
                  (m.shortcut)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(m.shortcut), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_29))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_33, [
          _withDirectives(_createElementVNode("textarea", {
            ref: "inputEl",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.input) = $event)),
            class: "nge-guide-input",
            rows: "1",
            placeholder: $setup.inputPlaceholder,
            onKeydown: $setup.onKeydown
          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_34), [
            [_vModelText, $setup.input]
          ]),
          _createElementVNode("button", {
            class: "nge-guide-send",
            disabled: $setup.loading || !$setup.input.trim(),
            onClick: _cache[5] || (_cache[5] = $event => ($setup.send()))
          }, "↑", 8 /* PROPS */, _hoisted_35)
        ])
      ], 4 /* STYLE */))
    : _createCommentVNode("v-if", true)
}